"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.globalFormMetadataParamsSchema = exports.formTypeSchema = exports.formMetadataParamsSchema = exports.contentTypeSchema = exports.contentBasedFormMetadataParamsSchema = exports.alaCarteFormMetadataParamsSchema = void 0;
var _zod = require("zod");
const formTypeSchema = exports.formTypeSchema = _zod.z.enum(["global", "contentbased", "alacarte"]);
const contentTypes = ["category", "collection"];
const contentTypeSchema = exports.contentTypeSchema = _zod.z.enum(contentTypes);
const formMetadataParamsBaseSchema = _zod.z.object({
  debug: _zod.z.boolean().optional()
});
const globalFormMetadataParamsSchema = exports.globalFormMetadataParamsSchema = formMetadataParamsBaseSchema.extend({
  formType: _zod.z.literal("global")
});
const contentBasedFormMetadataParamsSchema = exports.contentBasedFormMetadataParamsSchema = formMetadataParamsBaseSchema.extend({
  formType: _zod.z.literal("contentbased"),
  contentType: _zod.z.enum(contentTypes, {
    message: "contentType is required for contentbased forms"
  }),
  formId: _zod.z.string().min(1, {
    message: "formId is required for contentbased forms"
  })
});
const alaCarteFormMetadataParamsSchema = exports.alaCarteFormMetadataParamsSchema = _zod.z.union([formMetadataParamsBaseSchema.extend({
  formType: _zod.z.literal("alacarte"),
  modules: _zod.z.string().min(1, {
    message: "modules is required for alacarte forms"
  }),
  contentType: _zod.z.undefined(),
  formId: _zod.z.undefined()
}), formMetadataParamsBaseSchema.extend({
  formType: _zod.z.literal("alacarte"),
  modules: _zod.z.string().min(1, {
    message: "modules is required for alacarte forms"
  }),
  contentType: _zod.z.enum(contentTypes),
  formId: _zod.z.string().min(1)
})]);
const formMetadataParamsSchema = exports.formMetadataParamsSchema = _zod.z.union([globalFormMetadataParamsSchema, contentBasedFormMetadataParamsSchema, alaCarteFormMetadataParamsSchema]);